export const stripeFormId = "stripeForm";
export const stripeFormPaymentElementId = "stripeFormPaymentElement";

export const stripeFormFormTestId = "components/fragments/stripe/StripeForm/Form";
